import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Split({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Split.Outline {...props} /> : <Split.Solid {...props} />;
}

Split.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Split.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M22 4.86158C22 4.69098 21.9288 4.51954 21.7986 4.38938L19.6044 2.19508C19.3441 1.93477 18.9207 1.93518 18.66 2.19508L16.4588 4.38938C16.1981 4.64929 16.1985 5.07345 16.4588 5.33377C16.7191 5.59408 17.1429 5.59408 17.4032 5.33377L18.4656 4.27134C18.4656 8.17161 14.5663 11.3334 9.75802 11.3334L2.66661 11.3334C2.29845 11.3334 2 11.6318 2 12C2 12.3682 2.29845 12.6666 2.66661 12.6666L9.75802 12.6666C14.5663 12.6666 18.4656 15.8284 18.4656 19.7287L17.4032 18.6662C17.1429 18.4059 16.7191 18.4059 16.4588 18.6662C16.1985 18.9265 16.1981 19.3507 16.4588 19.6106L18.66 21.8049C18.9207 22.0648 19.3441 22.0652 19.6044 21.8049L21.7986 19.6106C21.9288 19.4805 22 19.309 22 19.1384C22 18.9678 21.9288 18.7964 21.7986 18.6662C21.5383 18.4059 21.1215 18.4059 20.8612 18.6662L19.7988 19.7287C19.7988 16.259 17.2806 13.2788 13.6882 12C17.2806 10.7212 19.7988 7.74104 19.7988 4.27134L20.8612 5.33377C21.1215 5.59408 21.5383 5.59408 21.7986 5.33377C21.9288 5.20361 22 5.03217 22 4.86158Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
